import { Box, IconButton, Typography, Chip } from "@mui/material";
import CustomDataGrid from "src/@core/components/data-grid";
import { styled } from "@mui/material/styles";
import { Edit, Delete } from "@mui/icons-material";
import moment from "moment";

function TableLessons({
  rows,
  totalCount,
  setCurrentPage,
  currentPage,
  setPageSize,
  pageSize,
  loading,
  toggleEdit,
  toggleStatus,
  toggleDelete,
  canEdit = true,
  canDelete = true,
}) {
  const statusColors = {
    Active: "#66bb6a",
    Inactive: "#FFB400",
  };
  const CustomChip = styled(Chip)(({ label }) => ({
    backgroundColor: statusColors[label] || "#666",
    color: "#fff",
    width: "100px",
    textTransform: "capitalize",
  }));

  const rowsWithSrNo = rows.map((row, index) => ({
    ...row,
    srNo: (currentPage - 1) * pageSize + index + 1,
  }));

  // Check if any actions are available
  const hasAnyActions = canEdit || canDelete;

  // Base columns
  const baseColumns = [
    { field: "srNo", headerName: "Sr No", minWidth: 100, sortable: false },
    {
      field: "title",
      headerName: "Title",
      minWidth: 250,
      sortable: false,
      renderCell: ({ row }) => (
        <Typography noWrap variant="body2" textTransform="capitalize">
          {row.title}
        </Typography>
      ),
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 300,
      sortable: false,
      renderCell: ({ row }) => (
        <Typography 
          noWrap 
          variant="body2" 
          sx={{ 
            maxWidth: 300,
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {row.description}
        </Typography>
      ),
    },
    {
      field: "file",
      headerName: "Video File",
      minWidth: 350,
      sortable: false,
      renderCell: ({ row }) => (
        <Typography variant="body2" sx={{ color: "primary.main" ,textWrap: "wrap"}}>
          {row.file || "No file"}
        </Typography>
      ),
    },
    {
      field: "created_at",
      headerName: "Created At",
      minWidth: 200,
      sortable: false,
      renderCell: ({ row }) => (
        <Typography variant="body2">
          {moment(row.created_at).format("MMM DD, YYYY hh:mm A")}
        </Typography>
      ),
    },
  ];

  // Actions column - only include if there are any actions available
  const actionsColumn = hasAnyActions ? {
    field: "Actions",
    headerName: "Actions",
    minWidth: 200,
    sortable: false,
    renderCell: ({ row }) => {
      const isDeleted = row.status === 2;
      const disabledStyle = { color: "#B0B0B0" };
      return (
        <Box display="flex" gap="10px">
          {canEdit && (
            <IconButton
              size="small"
              color="primary"
              onClick={(e) => toggleEdit(e, row)}
              disabled={isDeleted}
            >
              <Edit sx={isDeleted ? disabledStyle : {}} />
            </IconButton>
          )}
          {canDelete && (
            <IconButton
              size="small"
              color="primary"
              onClick={(e) => toggleDelete(e, row)}
              disabled={isDeleted}
            >
              <Delete sx={isDeleted ? disabledStyle : {}} />
            </IconButton>
          )}
        </Box>
      );
    },
  } : null;

  // Combine columns
  const columns = actionsColumn 
    ? [...baseColumns, actionsColumn]
    : baseColumns;

  return (
    <CustomDataGrid
      getRowId={(row) => row.id}
      loading={loading}
      rowCount={totalCount}
      rows={rowsWithSrNo}
      columns={columns}
      currentPage={currentPage}
      pageSize={pageSize}
      setCurrentPage={setCurrentPage}
      setPageSize={setPageSize}
    />
  );
}

export default TableLessons;
